import FileSelector  from "./FileSelector"

export default FileSelector;